export default __webpack_public_path__ + "static/media/2023-03-02T06_10_23.300Z_2_1.ecfb0f71.jpeg";